import { FC, PropsWithChildren } from "react";

import styles from "./Card.module.scss";

export const Card: FC<PropsWithChildren> = ({ children }) => {
  return <article className={styles.card}>{children}</article>;
};
